import firebase from 'firebase/app'
import 'firebase/messaging'

// Validate required environment variables
const isEnvValid = process.env.VUE_APP_FIREBASE_API_KEY &&
    process.env.VUE_APP_FIREBASE_PROJECT_ID &&
    process.env.VUE_APP_FIREBASE_SENDER_ID &&
    process.env.VUE_APP_FIREBASE_APP_ID

if (!isEnvValid) {
  console.warn('Firebase configuration is incomplete. Please check your environment variables.')
}

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_PROJECT_ID ? `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.firebaseapp.com` : '',
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || '',
  messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID || '',
  appId: process.env.VUE_APP_FIREBASE_APP_ID || ''
}

// Initialize Firebase only if configuration is valid
if (isEnvValid && !firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

let messaging = null

if (isEnvValid && firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
} else if (!isEnvValid) {
  console.warn('Firebase Messaging is disabled due to invalid configuration.')
}

export { messaging }